<div class="toolbar-wp" *ngIf="includeToolBar" [id]="toolbarId">
  <!-- placeholder for TinyMCE toolbar-->
</div>
<editor
  #richedit
  class="flex"
  [init]="init"
  licenseKey="gpl"
  [(ngModel)]="value"
  (ngModelChange)="onValueChanged($event)"
  (onFocusIn)="onFocus.emit($event)"
  (onFocusOut)="onBlur.emit($event)"
>
</editor>
